import { Button, CircularProgress } from "@mui/material";
import React from "react";

export default function CustomButton({
  children,
  loading,
  handleClick = () => {},
  bgcolor = "",
  color = "white",
  ...props
}) {
  return (
    <Button
      {...props}
      sx={{
        background:
          bgcolor || "linear-gradient(180deg, #9066FB 0%, #300ADD 100%)",
        borderRadius: "8px",
        width: "100%",
        color: color,
        textTransform: "none",
        "&.Mui-disabled": {
          background: "lightgray", // Background color when disabled
        },
      }}
      onClick={handleClick}
      // style={{}}
      variant="contained"
      fullWidth
    >
      {children}
      {loading && (
        <CircularProgress
          size={30}
          color="inherit"
          style={{ position: "absolute" }}
        />
      )}
    </Button>
  );
}
